<template>
    <div>
            <v-card flat style="border-radius:0%;border:solid #003b635b 1px;">
                <v-card-text style="text-align:center;background:#003B63;color:white;font-size:30px;font-weight: 600">
                    Gallery
                </v-card-text>
                <v-card-text>
                    <v-layout row class="ml-3 hidden-md-and-down">
                        <v-flex xs12 md3 v-for="(item, i) in gallery" :key="i" class="mb-5">
                            <v-img
                            @click="openWindows(item.img)"
                            :src="item.img" style="margin:0 auto;display:block;cursor:pointer;width:300px;height:300px;"></v-img>
                        </v-flex>
                    </v-layout>
                    <v-carousel class="hidden-md-and-up"
                        cycle
                        height="400"
                         hide-delimiters
                    >
                        <v-carousel-item
                        v-for="(item, i) in gallery"
                        :key="i"
                        >
                            <v-row
                            class="fill-height"
                            align="center"
                            justify="center"
                            >
                            <v-img
                            @click="openWindows(item.img)"
                            :src="item.img" style="cursor:pointer;width:90%;height:90%;"></v-img>
                            </v-row>
                        </v-carousel-item>
                    </v-carousel>
                </v-card-text>
            </v-card>
            <v-dialog v-model="windowsPanel" width="600">
                <v-card flat style="background:white;border-radius:0">
                    <v-img :src="imagenCompleta"></v-img>
                </v-card>
            </v-dialog>
    </div>
</template>

<style>
</style>

<script>
import { mapState, mapActions } from "vuex";
export default {
    data (){
        return {
            windowsPanel: false, imagenCompleta: ''
        }
    },
    created(){
        this.loadGallery()
    },
    computed:{
        ...mapState(['gallery'])
    },
    methods:{
        ...mapActions(['loadGallery']),
        openWindows(e){
            this.imagenCompleta = e
            this.windowsPanel = true
        }
    }
}
</script>